import React from "react";

const UserTypeDropdown = ({ handleFilters, selectedUserRole, setSelectedUserRole }) => {

  const handleSelectChange = (e) => {
    setSelectedUserRole(e.target.value);
    handleFilters(e.target.value);
  };

  return (
    <div className="dropdownUI">
      <label htmlFor="chemist-dropdown">
        Select User Role:
      </label>
      <select
        id="chemist-dropdown"
        value={selectedUserRole}
        onChange={handleSelectChange}
        className="allProductsTable__searchBox dropdown__filter"
      >
        <option value="">
          -- Select User Type --
        </option>
        <option value="Chemist">Chemist</option>
        <option value="Wholesaler">Wholesaler</option>
      </select>
    </div>
  );
};

export default UserTypeDropdown;
